import { Context, type Effect } from 'effect';

import type { Page } from '@vs-shop/domain/pagination';

import type { ProductSummary } from '../productSchema';
import type { FacetSet } from './facetSet';
import type { ProductListingError } from './errors';
import type { ListingPageRequest, ListingRequest } from './listingRequestKey';

/**
 * The products and the facets of one listing scope.
 *
 * - The scope decides the product set: a taxon, a brand or a search query.
 * - An empty selection lists the whole scope.
 * - A query that matches nothing is not an error. It answers an empty page.
 * - `NotFound` means that the backend answers 404 for the scope itself.
 */
export type ProductListingService = {
  readonly products: (
    request: ListingPageRequest
  ) => Effect.Effect<Page<ProductSummary>, ProductListingError>;
  readonly facets: (request: ListingRequest) => Effect.Effect<FacetSet, ProductListingError>;
};

export class ProductListing extends Context.Service<ProductListing, ProductListingService>()(
  '@engine/Capability/ProductListing'
) {}
